// extracted by mini-css-extract-plugin
module.exports = {"majorAmountInfo":"index_majorAmountInfo_2LLyL","amount":"index_amount_14REQ","text":"index_text_oC3ft"};